/*
 * @Name: axios
 * @Description: 请求封装
 * @Author: xiadongxue
 * @Date: 2021-10-20 09:44:10
 * @Editors: xiadongxue
 */
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import store from '../../store'
// 响应时间
axios.defaults.timeout = 60000;
// 配置请求头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
// 配置接口地址
axios.defaults.baseURL = CONFIG.baseUrl;
//默认携带cookie
axios.defaults.withCredentials = true

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
    config => {
        // 在发送请求之前做某件事
        if (config.method === "post") {
            if(config.headers['Content-Type'] === 'application/json;charset=UTF-8') {
                config.data = JSON.stringify(config.data);
            } else {
                config.data = qs.stringify(config.data);
            }
            
        }
        config.withCredentials = true
        config.headers['Access-Control-Allow-Credentials'] = true
        config.headers.token = JSON.parse(localStorage.getItem('token'))
        return config;
    },
    error => {
        console.log("错误的传参", "fail");
        return Promise.reject(error);
    }
);

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
    response => {
        let { code, reason, result } = response.data;
        //未登录重新登陆
        if (code === 2) {
            store.commit("USER_LOGIN", false)
        } else if(code === -17) {
            //密码三个月过期
            store.commit("USER_LOGIN", false)
            Vue.prototype.$confirm(reason, '提示', {
                confirmButtonText: '去重置',
                type: 'warning',
                showClose: false,
                showCancelButton: false,
                closeOnClickModal: false
            }).then(() => {
                window.location.href = result
            })
        } else if (code !== 0 && reason) {
            Vue.prototype.$message.error(reason);
        }
        return response.data;
    },
    error => {
        console.warn("axios response error");
        Vue.prototype.$message.error("服务器异常");
        return Promise.reject(error);
    }
);

let jsonPost = (url,data) => axios.post(url,data,{
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

export { axios, jsonPost};


